import { useState } from "react";
import { Box, Button, Dialog } from "@mui/material";
import { FiCheckCircle } from "react-icons/fi";
import { IoIosArrowBack } from "react-icons/io";
import { MdOutlineClose } from "react-icons/md";
import { useTheme } from "../../../style/theme";

const steps = [
    {
        title: "Welcome to Clikkle HR 🎉",
        image: "/images/gettingStarted1.png",
        content: (
            <div className="flex flex-col gap-5 items-start">
                <p className="text-[18px] md:text-[20px] mb-3 font-semibold">With Clikkle HR, you can:</p>
                <div className="flex items-baseline gap-3 justify-start">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[20px]">Enjoy smart hiring, simplified</p>
                        <p className="text-[12px] md:text-[16px]"> Manage HR tasks, post jobs,and organize the recruitment pipeline.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-bold md:text-[20px] text-[16px]">Keep everyone informed</p>
                        <p className="text-[12px] md:text-[16px]">  Broadcast announcements and company updates.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-bold text-[16px] md:text-[20px]">Keep your workforce organized</p>
                        <p className="text-[12px] md:text-[16px]">Manage employee documents, track leaves, and organize teams.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-bold text-[16px] md:text-[20px]">Ensure accurate, automated, hassle-free</p>
                        <p className="text-[12px] md:text-[16px]">Track attendance, streamline payroll, and stay compliant.</p>
                    </div>
                </div>
            </div>
        ),
    },
    {
        title: "Recruiter",
        image: "/images/gettingStarted2.png",
        content: (
            <div className="flex flex-col gap-5 items-start">
                <p className="text-[18px] md:text-[20px] mb-3 font-semibold">With Recruiter, you can:</p>
                <div className="flex items-baseline gap-3 justify-start">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Organize your workforce with custom departments & job positions</p>
                        <p className="text-[14px] md:text-[12px]">Define clear roles and structures within your organization by creating departments and job positions tailored to your needs.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Set tailored interview questions for smarter hiring</p>
                        <p className="text-[14px] md:text-[12px]">Ensure a seamless recruitment process by setting department-specific interview questions to evaluate candidates effectively.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Create & publish job listings to attract top talent</p>
                        <p className="text-[14px] md:text-[12px]">Post job openings on top job boards and connect with the best candidates to grow your organization.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Generate & manage job-specific agreement documents</p>
                        <p className="text-[14px] md:text-[12px]">Easily create, store, and manage legally binding agreements for various job positions within your company.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Track & monitor incoming job applications effortlessly</p>
                        <p className="text-[14px] md:text-[12px]">Stay on top of your hiring process by tracking and reviewing applications from potential employees in real time.</p>
                    </div>
                </div>
            </div>
        ),
    },
    {
        title: "Announcement",
        image: "/images/gettingStarted3.png",
        content: (
            <div className="flex flex-col gap-5 items-start">
                <p className="text-[18px] md:text-[20px] mb-3 font-semibold">With Announcement, you can:</p>
                <div className="flex items-baseline gap-3 justify-start">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Plan ahead with a holiday list for your team</p>
                        <p className="text-[14px] md:text-[12px]">Ensure employees enjoy their time off by creating a structured holiday list for better work-life balance.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Keep employees informed with important memos</p>
                        <p className="text-[14px] md:text-[12px]">Share crucial updates and key messages effortlessly, ensuring clarity and alignment across teams.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Stay updated with daily notices on the notice board</p>
                        <p className="text-[14px] md:text-[12px]">Keep your workforce in the loop with quick updates on small yet essential changes in the workplace.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Set clear expectations with company rules & regulations</p>
                        <p className="text-[14px] md:text-[12px]">Establish and communicate workplace policies to maintain professionalism, compliance, and a productive work environment.</p>
                    </div>
                </div>
            </div>
        ),
    },
    {
        title: "Team Chat",
        image: "/images/gettingStarted5.png",
        content: (
            <div className="flex flex-col gap-5 items-start">
                <p className="text-[18px] md:text-[20px] mb-3 font-semisemibold">With Team Chat, you can:</p>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Always stay in the loop</p>
                        <p className="text-[14px] md:text-[12px]">Get notified of important messages, mentions, and updates so you never miss out on what matters whether you’re on the go.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3 justify-start">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Enjoy instant messaging, seamless flow</p>
                        <p className="text-[14px] md:text-[12px]">Send quick messages, share updates, and keep the conversation going with no delays, no clutter, just real-time team sync.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Enjoy seamless file sharing</p>
                        <p className="text-[14px] md:text-[12px]">Attach documents, images, and more directly in chats. Stay productive by keeping important resources right where the conversation happens.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Converse in private and group channels</p>
                        <p className="text-[14px] md:text-[12px]">Create focused group chats for departments or projects, or start private conversations all in one organized workspace.</p>
                    </div>
                </div>
            </div>
        ),
    },
    {
        title: "Staff",
        image: "/images/gettingStarted4.png",
        content: (
            <div className="flex flex-col gap-5 items-start">
                <p className="text-[18px] md:text-[20px] mb-3 font-semibold">With Staff, you can:</p>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Centralized staff information at your fingertips</p>
                        <p className="text-[14px] md:text-[12px]">Easily access and manage all employee details from a single, organized platform.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3 justify-start">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Track active staff in your organization</p>
                        <p className="text-[14px] md:text-[12px]">Get a real-time view of all active employees to stay updated on workforce engagement.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Seamlessly add, import & export employee data</p>
                        <p className="text-[14px] md:text-[12px]">Effortlessly manage staff records by adding new employees or transferring data with just a few clicks.</p>
                    </div>
                </div>
                <div className="flex items-baseline gap-3">
                    <div>
                        <FiCheckCircle />
                    </div>
                    <div>
                        <p className="font-semibold text-[16px] md:text-[18px]">Filter employee information for quick insights</p>
                        <p className="text-[14px] md:text-[12px]">Customize your view to focus on the most relevant employee details when you need them.</p>
                    </div>
                </div>
            </div>
        ),
    },
];

export default function GettingStartedModal({ open, setOpen, step, setStep,setRecruiterOpen }) {
    let currentSubscription = JSON.parse(localStorage.getItem("subscription"));

    const permissions = currentSubscription?.plan?.permission || [];
    console.log(permissions, "orgorgorg");
  
    const hasPermission = (permissionName) => {
      return permissions.some(
        (permission) =>
          permission.key === permissionName && permission.isPermission
      );
    };
    const {mode} = useTheme();

    return (
        <Dialog open={open} onOpenChange={setOpen} PaperProps={{
            sx: {
                borderRadius: '10px',
                p: { md: 3, xs: 0 },
                width: '100%',
                margin: 0,
                maxWidth: { md: '97%', xs: "95%" },
                height: "100%",
                maxHeight: { md: "97%", xs: "95%" }
            },
        }}>
            <Box className="relative">
                <div style={{backgroundColor:mode === "dark" ? "" : "#ffff"}} className="sticky md:relative top-0 flex items-center justify-between w-full py-3 px-2 md:py-0 md:px-0">
                    <p className="text-[28px] font-bold hidden md:flex">Getting Started</p>
                    <div className="flex md:hidden">
                        {/* {step >= 1 && */}
                        <Box className='cursor-pointer' onClick={() => setStep((prev) => Math.max(prev - 1, 0))}>
                            <IoIosArrowBack sx={{ fontSize: "12px" }} />
                        </Box>
                        {/* } */}
                    </div>
                    <div className="flex md:hidden justify-center gap-1 md:gap-3">
                        {steps.map((_, index) => (
                            <div
                                key={index}
                                className={`h-1 w-8 rounded-full transition-all duration-300 ${index <= step ? "bg-[#0080FF]" : "bg-gray-200"
                                    }`}
                            />
                        ))}
                    </div>
                    <Box className='cursor-pointer' onClick={() => { setOpen(false) }}>
                        <MdOutlineClose className="md:text-[20px] text-[15px]" />
                    </Box>
                </div>
                <p className="text-[20px] font-bold md:hidden flex mt-6 px-2 md:px-0">Getting Started</p>
                <div className={`${step === 0 ? "md:mb-[-15px]" : ''} md:mt-3 ${step === 2 ? " md:mb-[-30px]" : ''} ${step === 3 ? " md:mb-[-35px]" : ''} px-2 md:px-0`}>
                    <div>
                        <p className="text-[18px] md:text-[20px] font-semibold">
                            {steps?.[step]?.title}
                        </p>
                    </div>
                </div>
                <div className="flex flex-col md:flex-row gap-6 px-2 md:px-0">
                    <div className="flex flex-col md:w-1/2 w-full">
                        <img
                            src={steps?.[step]?.image}
                            alt="Step visual"
                            className={`rounded-xl w-full h-[280px] md:h-[90%] ${step === 1 ? "md:ms-[-10px]" : ''} ${step === 2 ? "md:ms-[-20px]" : ''}`}
                        />
                        <div className="hidden md:flex justify-between mt-6 items-center">
                            {step === 4 &&
                                <Button />
                            }
                            {step != 4 &&
                                <Button
                                    variant="outlined"
                                    onClick={() => { setOpen(false) }}
                                    sx={{
                                        borderRadius: 5,
                                        color: '#0080FF',
                                        paddingX: 2
                                    }}
                                >
                                    Skip
                                </Button>
                            }
                            <div className="flex justify-center gap-3">
                                {steps.map((_, index) => (
                                    <div
                                        key={index}
                                        className={`h-1 w-10 rounded-full transition-all duration-300 ${index <= step ? "bg-[#0080FF]" : "bg-gray-200"
                                            }`}
                                    />
                                ))}
                            </div>
                            <div className="flex items-center gap-2">
                                {step >= 1 &&
                                    <Button
                                        variant="outlined"
                                        onClick={() => setStep((prev) => Math.max(prev - 1, 0))}
                                        sx={{
                                            borderRadius: 5,
                                            color: '#0080FF',
                                            paddingX: 2
                                        }}
                                    >
                                        Previous
                                    </Button>
                                }
                                <Button
                                    sx={{
                                        backgroundColor: "#0080FF",
                                        borderRadius: 5,
                                        color: 'white',
                                        paddingX: 2
                                    }}
                                    onClick={() => {
                                        if (step === steps.length - 1) {
                                          if (hasPermission("recruiting")) {
                                            setOpen(false);
                                            setRecruiterOpen(true);
                                          } else {
                                            setOpen(false); 
                                          }
                                        } else {
                                          setStep((prev) => Math.min(prev + 1, steps.length - 1));
                                        }
                                      }}
                                >
                                    {step === steps.length - 1 ? "Finish" : "Next"}
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className={`flex-1 flex flex-col justify-between md:w-1/2 w-full ${step === 0 ? 'md:mt-[15px]' : ""} ${step === 2 ? 'md:mt-[30px]' : ""} ${step === 3 ? 'md:mt-[35px]' : ""} `}>
                        {steps[step].content}
                    </div>
                    <div className="md:hidden flex justify-between mt-6 items-center px-2 md:px-0 mb-4">
                        {step != 4 &&
                            <Button
                                variant="outlined"
                                onClick={() => { setOpen(false) }}
                                sx={{
                                    borderRadius: 4,
                                    color: '#0080FF',
                                    paddingX: 2,
                                    fontSize: '14px'
                                }}
                            >
                                Skip
                            </Button>
                        }
                        <Button
                            sx={{
                                backgroundColor: "#0080FF",
                                borderRadius: 4,
                                color: 'white',
                                paddingX: 2,
                                fontSize: '14px'
                            }}
                            onClick={() => {
                                if (step === steps.length - 1) {
                                    setOpen(false);
                                } else {
                                    setStep((prev) => Math.min(prev + 1, steps.length - 1));
                                }
                            }}
                        >
                            {step === steps.length - 1 ? "Finish" : "Next"}
                        </Button>
                    </div>
                </div>
            </Box>
        </ Dialog >
    );
}
